import i18n from '../localization';
import booleanPointInPolygon from '@turf/boolean-point-in-polygon';
import circle from '@turf/circle';
import area from '@turf/area';
import {point, polygon} from '@turf/helpers';

export function checkEmptyObject(obj) {
    let guard = true;
    Object.keys(obj).forEach((key) => {
        if (obj[key]) {
            guard = false;
        }
    });

    return guard;
}

export function getUsableProducts(products, locale_id, order_type) {
    let filtered_products = products.filter((obj) => {
        return !(obj.mask_locali_esclusi & locale_id);
    });

    if (order_type === 'DELIVERY') {
        filtered_products = filtered_products.filter((obj) => {
            return !!obj.f_delivery;
        });
    }

    return filtered_products;
}

export function arrayToArrayOfGroups(array, property_name) {
    let groups = [];

    array.forEach((arrayItem) => {
        let found = groups.find((group) => {
            return group.find((item) => {
                return item[property_name] === arrayItem[property_name];
            });
        });

        if (found) {
            found.push(arrayItem);
        } else {
            groups.push([
                arrayItem
            ]);
        }
    });

    return groups;
}

export function getTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function getSurvivedItems(items, active_type, id_menu) {
    const survived_items = [];
    items.forEach((item) => {
        if (item.menu_presenti.includes(id_menu)
            && (active_type === 'DELIVERY' ? !!item.f_delivery : true) &&
            getProductPrice(item.item, active_type) === item.single_cost) {
            survived_items.push(item);
        }
    });

    return survived_items;
}

export function getProductPrice(item, orderType) {
    let piece_price = 0;
    if (item.prodotto_composto_tipo_prezzo !== 'VARIABILE') {
        let price = item.price.prezzo;
        if (['ORDINA_TAVOLO', 'MANGIA_RISTORANTE'].includes(orderType)) {
            if (item.price.prezzo_kmenu) price = item.price.prezzo_kmenu;
        }
        piece_price += price;
    }

    item.adds.forEach((add) =>
        piece_price += add.variazione_prezzo
    );

    item.free_picks.forEach((free_pick) => {
        if (free_pick) {
            piece_price += free_pick.variazione_prezzo
        }
    });

    item.prodotto_composto_associati.forEach((item) => {
        if (item) {
            piece_price += item.prezzo * item.qta;
        }
    });

    return piece_price;
}

export function getRewardName(reward, type, currency) {
    switch (type) {
        case 'VALORE':
            return reward.valore + ' ' + currency;
        case 'PERCENTUALE':
            return i18n.t("fidelity_card_sconto_del_1") + ' ' + reward.valore + i18n.t("fidelity_card_sconto_del_2");
        case 'PRODOTTO':
            let testo = "N/A";
            if (reward.tipologia && reward.tipologia.traduzioni.length) {
                if (!reward.id_prodotto || reward.id_prodotto === -1) {
                    //Un prodotto qualsiasi
                    testo = "1 " + reward.tipologia.traduzioni[0].nome;
                } else if (reward.prodotto && reward.prodotto.traduzioni.length) {
                    //Un prodotto specifico
                    testo = "1 " + reward.tipologia.traduzioni[0].nome + " - " + reward.prodotto.traduzioni[0].nome;
                }
            }
            return testo;
        default:
            return "N/A";
    }
}

export function canAddProductInCombo(category, picked, maxProd) {
    if (maxProd) {
        const totalPicked = picked.reduce((accumulator, pick) => {
            return accumulator + pick.qta;
        }, 0);

        if (totalPicked >= maxProd) {
            return false;
        }
    }

    if (category.max_prod_selezionabili) {
        const totalPicked = picked.reduce((accumulator, pick) => {
            if (pick.id_categoria === category.id_categoria)
                return accumulator + pick.qta;
            else
                return accumulator;
        }, 0);

        if (totalPicked >= category.max_prod_selezionabili) {
            return false;
        }
    }

    return true;
}

export function equalsInsensitive(text1, text2) {
    if (!text1) {
        return !text2;
    }

    if (!text2) {
        return false;
    }

    return text1.toLowerCase() === text2.toLowerCase();
}

export function trovaConsegneCitta(consegne_citta, lng, lat) {
    let possibiliConsegneCitta = [];

    consegne_citta.forEach((consegnaCitta) => {
        if (consegnaCitta.tipo_coordinate === 'POLYGON') {
            let turfPolygon = polygon([
                consegnaCitta.coordinate
                    .map((coordinata) => [coordinata.lng, coordinata.lat])
                    .concat([
                        [consegnaCitta.coordinate[0].lng, consegnaCitta.coordinate[0].lat],
                    ]),
            ]);

            if (booleanPointInPolygon(point([lng, lat]), turfPolygon)) {
                possibiliConsegneCitta.push({consegnaCitta, area: area(turfPolygon)});
            }
        } else if (consegnaCitta.tipo_coordinate === 'CIRCLE') {
            let turfCircle = circle(
                [
                    consegnaCitta.coordinate.center.lng,
                    consegnaCitta.coordinate.center.lat,
                ],
                consegnaCitta.coordinate.radius / 1000,
                {
                    steps: 10,
                    units: 'kilometers',
                },
            );
            if (booleanPointInPolygon(point([lng, lat]), turfCircle)) {
                possibiliConsegneCitta.push({consegnaCitta, area: area(turfCircle)});
            }
        }
    });

    return possibiliConsegneCitta;
}

export function trovaConsegnaCitta(consegne_citta, lng, lat) {
    const possibiliConsegneCitta = trovaConsegneCitta(consegne_citta, lng, lat);

    if (possibiliConsegneCitta.length) {
        // La più piccola vince
        let winner = null;
        possibiliConsegneCitta.forEach((consegnaCitta) => {
            if (!winner) {
                winner = consegnaCitta;
            } else {
                if (consegnaCitta.area < winner.area) {
                    winner = consegnaCitta;
                }
            }
        });

        return winner.consegnaCitta;
    }

    return null;
}

export function buildAddressFromGeoResult(geoResult, houseNumber) {
    if (geoResult) {
        const formattedAddress = [];
        const {address_components} = geoResult;

        let route = address_components.find((address_component) => {
            return address_component.types.includes('route');
        });
        if (route) formattedAddress.push(route.long_name);

        if (houseNumber) {
            if (formattedAddress.length) {
                formattedAddress[0] += ' ' + houseNumber;
            } else {
                formattedAddress.push(houseNumber);
            }
        }

        let postal_code = address_components.find((address_component) => {
            return address_component.types.includes('postal_code');
        });
        let administrative_area_level_3 = address_components.find(
            (address_component) => {
                return address_component.types.includes('administrative_area_level_3');
            },
        );

        if (administrative_area_level_3 && postal_code) {
            formattedAddress.push(
                postal_code.long_name + ' ' + administrative_area_level_3.long_name,
            );
        } else {
            if (administrative_area_level_3)
                formattedAddress.push(administrative_area_level_3.short_name);
            if (postal_code) formattedAddress.push(postal_code.long_name);
        }

        let administrative_area_level_2 = address_components.find(
            (address_component) => {
                return address_component.types.includes('administrative_area_level_2');
            },
        );
        if (administrative_area_level_2)
            formattedAddress.push(administrative_area_level_2.short_name);

        let administrative_area_level_1 = address_components.find(
            (address_component) => {
                return address_component.types.includes('administrative_area_level_1');
            },
        );
        if (administrative_area_level_1)
            formattedAddress.push(administrative_area_level_1.short_name);

        return formattedAddress.join(', ');
    }

    return null;
}

export function getGeoComponent(geoResult, type, property = 'long_name') {
    if (geoResult) {
        const component = geoResult.address_components.find((component) =>
            component.types.includes(type),
        );

        if (component) return component[property];
    }

    return null;
}

export const getGlovoStatus = (status) => {
    switch (status) {
        case "READY":
        case "ROUTED":
            return i18n.t("racer_ready");
        case "ASSIGNED_TO_COURIER":
        case "picking":
        case "almost_picking":
        case "waiting_at_pickup":
            return i18n.t("racer_assigned");
        case "ON_DELIVERY":
        case "delivering":
        case "almost_delivering":
        case "waiting_at_dropoff":
            return i18n.t("racer_on_delivery");
        case "DELIVERED":
        case "delivered":
            return i18n.t("racer_delivered");
        case "ON_RETURN_TO_WH":
        case "UNDELIVERABLE":
        case "RETURNED":
        case "returned":
        case "returning":
            return i18n.t("racer_undeliverable");
        case "CANCELLED":
        case "canceled":
            return i18n.t("racer_cancelled");
        default:
            return "";
    }
}

export const getGlovoCourier = (nominativo, telefono) => {
    let text = "";
    if (nominativo) {
        text += nominativo;
        if (telefono) text += " - ";
    }

    if (telefono) {
        text += telefono;
    }

    return text;
}
